var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBicep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bicep") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1,18.818a55.575,55.575,0,0,0,.673,9.821c.973,4.327,5.2,8.844,5.973,10.833C28.9,34.515,43.4,28.916,52.308,33.62,62.522,40.259,61.66,51.416,55,56.275c-2.056,1.5-8.512,4.482-17.174,4.7-6.876.174-11.838-.544-14-1.633-3.567.46-11.1.407-14.183-2.749C7.53,54.429,3.211,42.011,5.806,28.764,8.546,14.774,13.127,3,18.074,3c2.423,0,6.362.08,8.2,1.582s.517,5.977-.06,6.591a3.187,3.187,0,0,1,.631,4.263c-.954,1.605-4.33,3.281-5.606,3.6A7.442,7.442,0,0,1,18.1,18.818Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.319,47.819a24.414,24.414,0,0,0,18.454-2.637"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBicep);
export default __webpack_public_path__ + "static/media/bicep.3b786c0aceb2f744099b50c3dbecd9de.svg";
export { ForwardRef as ReactComponent };